module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qrepr7-5067a6594276c7d1a9b8333bb9164971.jpg";